import styled from 'styled-components';

export const StyledListingItemPriceLabel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ItemPriceDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
  line-height: 12px;
`;

export const StartPriceLabel = styled.span`
  font-size: 12px;
  margin: 2px 0 2px 0;
  text-align: end;
  color: ${({ theme }) => theme.palette.darkGrey};
  opacity: 0.75;
`;

export const PriceInEUR = styled.span`
  color: ${({ theme }) => theme.palette.NL800};
  font-size: 24px;
  font-weight: 600;
  text-align: right;
  height: 30px;
  margin-top: -3px;
`;

export const WorldPriceWrapper = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  background: #6f328a;
  height: 33px;
`;

export const WorldPriceTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Separator = styled.div`
  width: 1px;
  height: 24px;
  background: #c1c7d0;
`;

export const WorldPriceMobileWrapper = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 2px;
  border-radius: 8px;
  background: #6f328a;
  height: 52px;
`;
